import FocusableIconButton from '@components/FocusableIconButton';
import { usePrescriptionContext } from '@context/Prescription';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { PRESCRIPTION_DELIVERY_VISIT } from '@pages/Prescription/focusKey';

import * as styles from './styles';

const DeliverySelection = () => {
  const { goDelivery } = usePrescriptionContext();

  const { ref, focusKey } = useFocusable();

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} css={styles.container}>
        <div css={styles.title}>처방약 수령 방법 선택하기</div>
        <FocusableIconButton
          iconType="arrow"
          focusKey={PRESCRIPTION_DELIVERY_VISIT}
          onEnterPress={() => goDelivery('visit')}
        >
          주변 약국에서 받기
        </FocusableIconButton>
      </div>
    </FocusContext.Provider>
  );
};

export default DeliverySelection;
